import vClickOutside from 'v-click-outside';

import eventBus from '../../common/event-bus/event-bus';

export default {
	name: 'mdl09-same-item-in-cart',
	directives: {
		clickOutside: vClickOutside.directive
	},
	methods: {
		toggle() {
			eventBus.$emit('close-sameItemInCartPopup');
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL09-same-item-in-cart/MDL09-same-item-in-cart.js